export interface GenerateForms720DraftPdfPayload {
  modelo: string
  ejercicio: string
  f01: string
  idi: string
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined
  }

  const text = String(value).trim()
  return text.length > 0 ? text : undefined
}

export function buildGenerateForms720DraftPdfPayload(input: any): GenerateForms720DraftPdfPayload {
  return {
    modelo: '720',
    ejercicio: toStringValue(input?.ejf ?? input?.ejercicio) as string,
    f01: toStringValue(input?.fic ?? input?.f01) as string,
    idi: toStringValue(input?.idi) as string,
  }
}
